import GenericActionField from 'automation-ui-action-features/actions/extension/generic-extension/GenericActionField';
import { isParentChildrenFieldDependency } from 'automation-ui-action-features/actions/extension/utils/fieldVisibility';
const isGenericActionField = value => value instanceof GenericActionField;
export const getParentFieldDependencies = ({
  fieldDependencies,
  fieldKey
}) => fieldDependencies.filter(fieldDependency => {
  if (isParentChildrenFieldDependency(fieldDependency)) {
    return fieldDependency.childFieldNames.includes(fieldKey);
  } else {
    /**
     * NOTE(bheng): In the future we should separate dependency concerns to
     *   control separate logic (visibility, edit-ability, sharing data),
     *   but for now, overload edit-ability in order to limit data shared
     *   between fields.
     */
    return fieldDependency.dependencyType === 'SINGLE_FIELD' && fieldDependency.dependentFieldNames.includes(fieldKey);
  }
});

/**
 * Given an array of field dependencies, fetch the dependent field values for a
 * particular field key.
 */
export const getDependentFields = ({
  fieldDependencies,
  fieldKey,
  metadataFields
}) => getParentFieldDependencies({
  fieldDependencies,
  fieldKey
}).map(fieldDependency => metadataFields.find(field => {
  const currentFieldKey = field.getFieldKey();
  if (isParentChildrenFieldDependency(fieldDependency)) {
    return currentFieldKey === fieldDependency.parentFieldName;
  } else {
    return currentFieldKey === fieldDependency.controllingFieldName;
  }
}) || new GenericActionField({
  fieldKey
})).filter(isGenericActionField);
export const getParentActionFields = ({
  fieldDependencies,
  inputActionName
}) => fieldDependencies.filter(fieldDependency => {
  if (isParentChildrenFieldDependency(fieldDependency)) {
    return fieldDependency.childActionNames.includes(inputActionName);
  } else {
    return fieldDependency.dependencyType === 'SINGLE_FIELD' && (fieldDependency.dependentActionNames || []).includes(inputActionName);
  }
});
export const getDependentActionFields = ({
  fieldDependencies,
  inputActionName,
  metadataFields
}) => fieldDependencies.filter(fieldDependency => {
  if (isParentChildrenFieldDependency(fieldDependency)) {
    return fieldDependency.childActionNames.includes(inputActionName);
  } else {
    return fieldDependency.dependencyType === 'SINGLE_FIELD' && (fieldDependency.dependentActionNames || []).includes(inputActionName);
  }
}).map(fieldDependency => metadataFields.find(field => {
  const fieldKey = field.getFieldKey();
  if (isParentChildrenFieldDependency(fieldDependency)) {
    return fieldKey === fieldDependency.parentFieldName;
  } else {
    return fieldKey === fieldDependency.controllingFieldName;
  }
}) || new GenericActionField({
  fieldKey: inputActionName
})).filter(isGenericActionField);